import style from './index.module.styl'
import { ActivateDialog, AwardDialog } from '@/components/dialog'
import API from '@/api'
import dayjs from 'dayjs'
import exchangeMixin from '@/common/js/exchange-mixin.js'

const STATUS_MAP = {
  '0': '处理中',
  '1': '已完成兑换',
  '2': '已发货'
}

export default {
  mixins: [exchangeMixin],
  components: {
    ActivateDialog,
    AwardDialog
  },
  data() {
    return {
      visible: false,
      avatar: '',
      isVip: false,
      effect: '',
      myExchangeList: [],
      isShopDown: false,
      isLogDown: false,
    }
  },
  created() {
    this.getMyInfo()
    this.getMyExchangeLog()
  },
  methods: {
    handleClickShopBar() {
      this.isShopDown = !this.isShopDown
    },
    handleClickLogBar() {
      this.isLogDown = !this.isLogDown
    },
    handleCloseDialog() {
      this.visible = false
    },
    handleOpenDialog() {
      this.visible = true
    },
    handleActiveSucceed() {
      this.visible = false
      this.getMyInfo()
    },
    /*
     * 我的信息
     */
    async getMyInfo() {
      try {
        const resp = await this.$http({
          method: 'POST',
          url: API.getUserInfo,
          params: {
            token: this.$storage.getItem('token'),
            openid: this.$storage.getItem('openid'),
            activity_id: this.$route.params.eventId,
            user_id: this.$storage.getItem('s_uid')
          }
        })

        this.avatar = resp.avatar
        this.isVip = resp.isVip
        this.effect = resp.effect
        this.$store.dispatch('setMyAward', {
          points: resp.points,
          redbag: resp.redbag,
          availablePoints: resp.availablePoints,
          usedPoints: resp.usedPoints,
        })
      } catch (error) {
        console.error(error)
      }
    },
    /**
     * 我的兑换记录
     */
    async getMyExchangeLog() {
      try {
        const resp = await this.$http({
          method: 'POST',
          url: API.getMyAward,
          params: {
            token: this.$storage.getItem('token'),
            openid: this.$storage.getItem('openid'),
            activity_id: this.$route.params.eventId,
            user_id: this.$storage.getItem('s_uid')
          }
        })

        this.myExchangeList = resp.myAward
      } catch (error) {
        console.error(error)
      }
    }
  },
  render(h) {
    const {redbag, points, availablePoints, usedPoints } = this.$store.state.myAward
    const awardInfo = this.$store.state.awardInfo

    return (
      <div class={style['my-wrapper']}>
        <div class={style['header']} style={this.$route.params.eventId == 309878?'background-color:rgb(234,23,36)':''}>
          <img src={this.avatar} />
          <div class={style['right-part']}>
            <div class={style['title']}>已获红包&nbsp;￥{redbag}</div>
            <div class={style['desc']}>影响力&nbsp;{this.effect}</div>
          </div>
        </div>

        <div class={style['desc-bar']}>
          <div class={style['bar-item']}>
            <div class={style['text']}>累计{this.$store.state.keyword}</div>
            <div class={style['num']}>{points}</div>
          </div>
          <div class={style['bar-item']}>
            <div class={style['text']}>已用{this.$store.state.keyword}</div>
            <div class={style['num']}>{usedPoints}</div>
          </div>
          <div class={style['bar-item']}>
            <div class={style['text']}>可用{this.$store.state.keyword}</div>
            <div class={style['num']}>{availablePoints}</div>
          </div>
        </div>

        {
          this.$route.params.eventId != 309878 && (<div class={style['card']}>
            <div class={style['title']}>
              <i class={[style['icon'], style['icon-diamond']]}></i>
              <span>激活会员卡</span>
            </div>
            <div class={style['content']}>
              <div class={{[style['box']]: true, [style['isVip']]: this.isVip}}>
                <div class={style['label']}>VIP</div>
                {
                  !this.isVip ? (<div class={style['btn']} onClick={this.handleOpenDialog}>点击激活</div>
                  ) : (<div class={style['btn']}>已激活</div>
                  )
                }
              </div>
            </div>
          </div>)
        }
        
        {
          this.$route.params.eventId != 309878 && (
            <div class={style['tab-card']}>
              <div class={style['title']} onClick={this.handleClickShopBar}>
                <div class={style['left']}>
                  <i class={[style['icon'], style['icon-shop']]}></i>
                  <span>{this.$store.state.keyword}商城</span>
                </div>
                <i class={{
                  [style['icon-arrow-down']]: !this.isShopDown,
                  [style['icon-arrow-up']]: this.isShopDown,
                  [style['icon']]: true
                }}></i>
              </div>
              <div class={{
                [style['content']]: true,
                fadeOut: this.isShopDown,
                fadeIn: !this.isShopDown,
                animated: true,
                fast: true,
              }}>
                {
                  !this.isShopDown && awardInfo.map(d => (
                    <div class={style['item']} key={d.id} data-id={d.id} data-type="award" onClick={this.handleOpenExchangeDialog}>
                      <div class={style['left']}>
                        <img src={d.award_img}/>
                        {
                          this.$route.params.eventId != 309878 && (<div class={style['text']}>剩余&nbsp;{d.stock}</div>)
                        }
                      </div>
                      <div class={style['middle']}>
                        <div class={style['item-title']}>{d.award_name}</div>
                        <div class={style['desc']}>参与任务，达标<span style={`color: red;`}>&nbsp;{d.points}&nbsp;</span>{this.$store.state.keyword}可领取
                        </div>
                      </div>
                      <div class={style['right']}>
                        <span class={style['btn']}>详情</span>
                      </div>
                    </div>
                  ))
                }
              </div>
            </div>
          )
        }

        <div class={style['tab-card']}>
          <div class={style['title']} onClick={this.handleClickLogBar}>
            <div class={style['left']}>
              <i class={[style['icon'], style['icon-exchange']]}></i>
              <span>{this.$route.params.eventId != 309878 ? '兑换记录':'我的礼品'}</span>
            </div>
            <i class={{
              [style['icon-arrow-down']]: !this.isLogDown,
              [style['icon-arrow-up']]: this.isLogDown,
              [style['icon']]: true
            }}></i>
          </div>
          <div class={{
            [style['content']]: true,
            fadeOut: this.isLogDown,
            fadeIn: !this.isLogDown,
            animated: true,
            fast: true,
          }}>
            {
              !this.isLogDown && this.myExchangeList.map(d => (
                <div class={style['item']} key={d.id} data-id={d.id} data-hide-btn={true} data-type="award" onClick={this.handleOpenExchangeDialog}>
                  <div class={style['left']}>
                    <img src={d.award_img} alt="" />
                  </div>
                  <div class={style['middle']}>
                    <div class={style['item-title']}>{d.award_name}</div>
                    <div class={style['desc']}>{this.$route.params.eventId != 309878 ? '申请兑换时间':'获得时间'}：{dayjs(d.created_at).format('YYYY-MM-DD')}</div>
                  </div>
                  <div class={[style['right']]}>
                    <div class={style['label']}><span>{STATUS_MAP[d.log_status]}</span></div>
                    <span class={style['btn']}>详情</span>
                  </div>
                </div>
              ))
            }
          </div>
        </div>

        <div class={style['bottom-tips']}>
          <div class={style['title']}>--&nbsp;&nbsp;Tips&nbsp;&nbsp;--</div>
          <div class={style['desc-content']}>
            <p>1. 返回首页，仔细查阅活动奖励介绍</p>
            <p>2. 参与活动获得微信红包、{this.$store.state.keyword}、{this.$store.state.keyword}可兑换礼品；</p>
            <p>3. 最终解释权归活动主办方</p>
          </div>
        </div>
        <activate-dialog
          onActiveSucceed={this.handleActiveSucceed}
          onClickCloseBtn={this.handleCloseDialog}
          visible={this.visible} />
        <award-dialog
          type={this.awardType}
          awardItem={this.awardItem}
          id={this.awardId}
          onReceiveAwardSucceed={this.handleExchangeActiveSucceed}
          onClickCloseBtn={this.handleCloseExchangeDialog}
          visible={this.exchangeVisible} />
      </div>
    )
  }
}